import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBagIcon, XIcon } from "lucide-react";
import { POPUP_BUYERS } from "./data";
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: ReturnType<typeof setTimeout>;
    let hideTimer: ReturnType<typeof setTimeout>;
    const cycle = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % POPUP_BUYERS.length);
        showTimer = setTimeout(cycle, 6000);
      }, 5000);
    };

    // first appearance after a short delay
    showTimer = setTimeout(cycle, 4000);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [dismissed, index]);
  const buyer = POPUP_BUYERS[index];
  const minutes = index % 9 + 1;
  return <AnimatePresence data-id="element-204" data-mp="164o8g2pc3xsl">
      {visible && !dismissed && <motion.div initial={{
      x: -120,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -120,
      opacity: 0
    }} transition={{
      type: "spring",
      stiffness: 260,
      damping: 24
    }} className="fixed bottom-24 left-3 z-30 w-[260px] max-w-[80vw] rounded-2xl border border-gray-100 bg-white p-3 shadow-2xl sm:bottom-6" data-id="element-205" data-mp="117628k2pbwoa">
          <button onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 text-gray-300 hover:text-gray-500" data-id="element-206" data-mp="n8y6uglbd3f8">
            <XIcon className="h-4 w-4" data-id="element-207" data-mp="x2yasf4v02md" />
          </button>
          <div className="flex items-center gap-3 pr-4" data-id="element-208" data-mp="s5ewxgc2pruy">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[var(--cta)]/15" data-id="element-209" data-mp="28k7r4ssoyejg">
              <ShoppingBagIcon className="h-5 w-5 text-[var(--cta-dark)]" data-id="element-210" data-mp="23m68ua33aj91" />
            </div>
            <div className="min-w-0" data-id="element-211" data-mp="2ap3037xgwma4">
              <p className="truncate text-sm font-bold text-gray-800" data-id="element-212" data-mp="2ao1l4sdbzfn4">
                {buyer.name} · {buyer.country}
              </p>
              <p className="text-xs leading-tight text-gray-500" data-id="element-213" data-mp="2kmr6ww8clk8n">
                Acaba de adquirir el Protocolo Clínica Segura™
              </p>
              <p className="mt-0.5 text-[10px] font-medium text-[var(--cta-dark)]" data-id="element-214" data-mp="2pkiyfp52z4cb">
                Hace {minutes} min · Compra verificada
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}